import { NumericFormat } from "react-number-format";

import { Input } from "src/components/ui/input";
import { cn } from "src/lib/utils";
import { Field, type FieldProps } from "./Field";

export interface NumberFieldProps extends Pick<FieldProps, "label" | "error" | "hint"> {
	name?: string;
	placeholder?: string;
	required?: boolean;
	disabled?: boolean;
	autoComplete?: string;
	value?: string | number;
	/** Receives the raw numeric string (no separators) — same contract as the legacy `NumberFormInput`. */
	onChange?: (value: string) => void;
	/** Currency or unit prefix, e.g. `"₦ "`. */
	prefix?: string;
	decimalScale?: number;
	className?: string;
	containerClassName?: string;
}

/** Thousand-separated numeric input. Renders the shadcn `<Input>` so it matches every other control. */
export const NumberField = ({
	label,
	error,
	hint,
	name,
	required,
	value,
	onChange,
	className,
	containerClassName,
	...props
}: NumberFieldProps) => (
	<Field label={label} name={name} required={required} error={error} hint={hint} className={containerClassName}>
		<NumericFormat
			customInput={Input}
			id={name}
			name={name}
			value={value}
			onValueChange={(values) => onChange?.(values.value)}
			allowLeadingZeros
			valueIsNumericString
			thousandSeparator=","
			aria-invalid={!!error}
			className={cn(error && "tw-border-red focus-visible:tw-border-red focus-visible:tw-ring-red/20", className)}
			{...props}
		/>
	</Field>
);

export default NumberField;
